import Icon from "@mui/icons-material/HowToReg";

import MiqaatAttendanceCreate from "./MiqaatAttendanceCreate";
import MiqaatAttendanceList from "./MiqaatAttendanceList";
import MiqaatAttendanceShow from "./MiqaatAttendanceShow";

export default {
  list: MiqaatAttendanceList,
  create: MiqaatAttendanceCreate,
  show: MiqaatAttendanceShow,
  icon: Icon,
  label: "Miqaat attendance",
  options: { label: "Miqaat attendance" },
  name: "miqaatAttendance",
};
